import React from 'react';
import _ from 'lodash';
import sc from 'styled-components';
import Input from '../../views/InputBouncy';
import compString from '../../utils/compString';
import { Icon } from 'antd';
import { RED_ERROR } from '../../views/styleConstants';


const keywordInputStyle = {
  width: '100%',
};

export default (bottle) => {
  bottle.factory('spottingGroupDrilldownColumns', () => setKeyword => [
    {
      title: 'Keyword',
      dataIndex: 'keyword',
      sorter: (vocA, vocB) => compString(
        _.get(vocA, 'keyword', ''),
        _.get(vocB, 'keyword', ''),
        true,
      ),
      sortDirections: ['ascend'],
      render: (keyword, row, tabIndex) => (<Input
        style={keywordInputStyle}
        tabIndex={tabIndex + 10000}
        onChange={(event) => {
            setKeyword({
              keyword: event.target.value,
              id: row.id,
            });
          }}
        value={keyword}
      />),
    },
    {
      key: 'termError',
      title: '',
      dataIndex: 'keyword',
      render: (keyword, record) => {
        if (record.isError) {
          return (<Icon
            style={{ fontSize: '16px' }}
            type="exclamation-circle"
            theme="twoTone"
            title={record.error || 'bad characters in term'}
            twoToneColor={RED_ERROR}
          />);
        }
        return '';
      },
      width: 30,
    },
  ]);
};
